import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CaretIcon from 'modules/Common/components/svg/CaretIcon';
import ordinalSuffix from "utils/OrdinalSuffix";
import {formatCurrency} from "utils/CurrencyFormatting";
import { localTime } from 'utils/LocalDateTimeHelper';
import {Link} from 'react-router';
import { preventLinkScroll } from 'utils/commonUtils';
import { raceStatusLabel } from 'modules/HorseRacing/utils';
import Dropdown from 'modules/Common/components/Dropdown';

export default class HorseRacingRacecardSummary extends Component{
  static propTypes = {
    sortOptions: PropTypes.array,
    sortOrder: PropTypes.string,
    setSortOrder: PropTypes.func,
    prizes: PropTypes.arrayOf(PropTypes.object),
    raceSummary: PropTypes.object,
    isComplete: PropTypes.bool,
    params: PropTypes.object,
    stewards: PropTypes.string,
    "result-racecard": PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {expanded: false};
  }

  distanceFormat(dist) {
    if (dist) {
      return dist.replace(" 0f", "").replace(" 0y", "");
    }
  }

  toggleExpanded() {
    this.setState({expanded: !this.state.expanded});
  }

  surfaceFormat(surf) {
    const a = surf.toLowerCase();
    return a.charAt(0).toUpperCase() + a.slice(1);
  }

  prizeList(prizes) {
    return <OptionalData className="hr-racecard-summary-prizes">{prizes.sort((a, b) => (a.position - b.position)).map(prize => {
      const label = ((prize.amended_position || prize.position) === 1) ? "Winner" : ordinalSuffix(prize.amended_position || prize.position);
      const [amount, currencyCode] = prize.prize.split(" ");

      return <span className="hr-racecard-summary-prize" key={prize.amended_position || prize.position}>
        <span className="hr-racecard-summary-prize-label">{label}</span>
        {formatCurrency(amount, currencyCode)}
      </span>
    })}
    </OptionalData>;
  }

  render(){
    const {
      params: {
        date,
        courseSlug,
        raceId,
        raceSlug
      },
      prizes,
      isComplete,
      raceSummary: {
        date: raceDate,
        winning_time : winningTime,
        off_time : offTime,
        course_surface : {
          surface : courseSurface
        },
        distance : raceDistance,
        race_class: raceClass,
        going : raceGoing,
        name : raceName = 'unknown',
        race_stage : raceStage
      },
      stewards,
      sortOptions,
      sortOrder,
      setSortOrder
    } = this.props;

    const racecardHref = `/racing/racecards/${date}/${courseSlug}/racecard/${raceId}/${raceSlug}`;
    const resultHref = `/racing/results/${date}/${courseSlug}/${raceId}/${raceSlug}`;

    return (
      <div>
        <section className="hr-racecard-summary-wrapper">
          <ul className={`hr-racecard-summary-information-wrapper${this.state.expanded?" hr-racecard-summary-open":""}`}>
            <li className="hr-racecard-summary-race-name hr-racecard-summary-always-open">{raceName} {raceClass && `(Class ${raceClass})`}</li>
            {(!!raceDistance || !!raceGoing) &&
              <li className="hr-racecard-summary-race-distance hr-racecard-summary-always-open">{this.distanceFormat(raceDistance)}, {raceGoing}</li>
            }
            <li className="hr-racecard-summary-race-runners hr-racecard-summary-always-open">{this.props.raceSummary.ride_count} Runners</li>
            {this.prizeList(prizes)}
            <OptionalData className="hr-racecard-summary-surface">Surface: { courseSurface ? this.surfaceFormat(courseSurface) : 'unknown'}</OptionalData>
          </ul>
          <div className={`hr-racecard-more-detail-${sortOptions?"with":"no"}-sort`}>
            <div className="hr-racecard-show-more">
              <button onClick={e=>this.toggleExpanded(e)}>
                {this.state.expanded && <span><CaretIcon type="full" direction="up"/> Show Less</span>}
                {!this.state.expanded && <span><CaretIcon type="full" direction="down"/> Show More</span>}
              </button>
            </div>
            {sortOptions && <div className="hr-racecard-sort">
              <span className="hr-racecard-sort-text">Sort By:</span>
              <Dropdown
                className="sort-dropdown"
                options={sortOptions}
                value={sortOrder}
                onChange={(value) => setSortOrder(value)}
                title="Order?"
                showSelected
                noOptionsMessage="No options"
              />
            </div>}
          </div>
          {stewards === "AMENDEDRESULT" &&
            <span className="hr-racecard-summary-stewards">Result amended following stewards enquiry</span>
          }
        </section>
        {isComplete &&
          <div className="hr-racecard-weighed-in-wrapper">
            <div className="hr-racecard-weighed-in-title-row">
              <h3 className="hr-racecard-weighed-in-title">{raceStatusLabel(raceStage)}</h3>
              <div>
                <Link className="hr-racecard-weighed-in-card-result-switch" activeClassName="hr-racecard-weighed-in-card-result-switch-active" to={preventLinkScroll(racecardHref)}>Racecard</Link>
                <Link className="hr-racecard-weighed-in-card-result-switch" activeClassName="hr-racecard-weighed-in-card-result-switch-active" to={preventLinkScroll(resultHref)}>Result</Link>
              </div>
            </div>
            <div className="hr-racecard-weighed-in-info">
              <span className="hr-racecard-weighed-in-wt">
                Winning time:<span>{winningTime ? winningTime : '-'}</span>
              </span>
              <span className="hr-racecard-weighed-in-ot">
                Off time:<span>{offTime ? localTime(`${raceDate}T${offTime}Z`) : '-'}</span>
              </span>
            </div>
          </div>
        }
      </div>
    );
  }
}

function OptionalData(props) {
  return props.children
       ? (
           <li className={props.className}>{props.children}</li>
         )
       : null;
}
OptionalData.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
};



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingRacecardSummary.js